export default __webpack_public_path__ + "static/media/carousel-2-smart-data-economy-v4.cd64712c.png";